<template>
  <main>
    <st-header v-if="header" :header="header"></st-header>
    <!-- <reuters v-if="isReuters"></reuters> -->
    <!-- <reuters-page v-if="isReuters"></reuters-page> -->
    <st-article></st-article>
  </main>
</template>

<script>
import {mapState} from 'vuex'
import StHeader from './header/st-header.vue'
import StArticle from './st-article.vue'
import Reuters from './reuters.vue'
import ReutersPage from './reuterspage.vue'

export default {
  components: {StHeader, StArticle, Reuters, ReutersPage},
  computed: {
    ...mapState(['header']),
    isReuters () {
      return process.env.IS_REUTERS
    }
  }
}
</script>
